<template>
    <div class="form-container">
        <TeItiKahurangiStart
            v-if="!showForm"
            v-model="selectedClient"
            :myStep="0"
            @accepted="onAccepted"
            @open-form="onOpenExisting"
        />
        <TeItiKahurangiFormEntry
            v-else
            :selectedClient="selectedClient"
            :agreement="agreement"
            :formId="formId"
            @exit="onExit"
        />
    </div>
</template>

<script>
import TeItiKahurangiStart from "./TeItiKahurangiStartComponent.vue";
import TeItiKahurangiFormEntry from "./TeItiKahurangiEntryComponent.vue";

const TeitiKahurangi = {
    name: "TeItiKahurangi",
    components: {
        TeItiKahurangiStart,
        TeItiKahurangiFormEntry
    },
    data: () => ({
        selectedClient: null,
        agreement: false,
        showForm: false,
        formId: null
    }),
    methods: {
        onAccepted() {
            this.agreement = true;
            this.showForm = true;
        },
        onOpenExisting(id) {
            this.formId = id;
            this.agreement = true; // consent already implied by reviewing
            this.showForm = true;
        },
        onExit() {
            this.showForm = false;
            this.selectedClient = null;
            this.agreement = false;
            this.formId = null;
        }
    }
};
export default TeitiKahurangi;
</script>

<style scoped>
@import '../../../assets/styles/home.css';
@import '../../../assets/styles/forms.css';
</style>